<template>
    <div class="bottom-menu">
        <div class="bottom-menu-actions-container">
            <ul class="bottom-menu-items-container">
                <li class="bottom-menu-item"
                    v-for="(item, index) in barItems" :key="index"
                    @click="goto(item.path)"
                    :class="{active: item.active}">
                        <fa :icon="item.icon" class="bottom-menu-icon" />
                        <p class="bottom-menu-text">{{item.description}}</p>
                </li>

                <li class="bottom-menu-item"
                    :class="{active: isMoreActionActive}"
                    @click="toggleMoreActions()">
                        <fa icon="plus" class="bottom-menu-icon" />
                        <p class="bottom-menu-text">Mais</p>
                </li>
            </ul>
        </div>

        <div class="bottom-menu-more-actions-container" v-if="showMoreActions">
            <div class="bottom-menu-more-actions-name-container">
                <p>Mais ações</p>
            </div>

            <div class="bottom-menu-more-actions-section" v-for="section in moreSections" :key="section.key">
                <p class="bottom-menu-more-actions-section-title">{{section.title}}</p>

                <ul class="bottom-menu-more-actions-list">
                    <li class="bottom-menu-more-actions-item"
                        v-for="action in section.items" :key="action.path"
                        :class="{active: action.active}"
                        @click="goto(action.path)">
                        <p class="bottom-menu-more-actions-item-description">{{action.description}}</p>
                        <fa icon="chevron-right" class="bottom-menu-more-actions-item-icon"/>
                    </li>
                </ul>
            </div>

            <div class="bottom-menu-more-actions-section">
                <p class="bottom-menu-more-actions-section-title">Conta</p>

                <ul class="bottom-menu-more-actions-list">
                    <li class="bottom-menu-more-actions-item" @click="goto('/empresas')" v-if="hasMoreThanOneSubscriber">
                        <p class="bottom-menu-more-actions-item-description">Empresas</p>
                        <fa icon="chevron-right" class="bottom-menu-more-actions-item-icon" />
                    </li>

                    <li class="bottom-menu-more-actions-item" @click="toggleTheme()">
                        <p class="bottom-menu-more-actions-item-description">{{themeLabel}}</p>
                        <!-- so o desenho do sol/lua: o clique e da linha inteira -->
                        <ThemeToggleCmp class="bottom-menu-more-actions-item-theme" tabindex="-1" aria-hidden="true" />
                    </li>

                    <li class="bottom-menu-more-actions-item item-logout" @click="logout()">
                        <p class="bottom-menu-more-actions-item-description">Sair</p>
                        <fa icon="power-off" class="bottom-menu-more-actions-item-icon" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {logout} from '@/auth/services/SessionService'
import {createMenuSections, flattenMenuSections, activateMenuRoute} from '@/menu/MenuItems'
import ThemeToggleCmp from '@/menu/components/ThemeToggleCmp'
import {isDarkTheme, toggleTheme} from '@/utils/services/ThemeService'

const BAR_PATHS = ['/dashboard', '/pedidos', '/produtos']

export default {
    name: 'BottomMenuCmp',
    components: {
        ThemeToggleCmp,
    },
    data() {
        return {
            showMoreActions: false,
            menuSections: createMenuSections(),
        }
    },
    methods: {
        goto(path) {
            this.showMoreActions = false

            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        toggleMoreActions() {
            this.showMoreActions = !this.showMoreActions
        },
        toggleTheme() {
            toggleTheme()
        },
        async logout() {
            await logout()
        },
        _activateRoute(path) {
            activateMenuRoute(this.menuItems, path)
        },
    },
    mounted() {
        this._activateRoute(this.$route.path)
    },
    computed: {
        ...mapState({
            subscriberList: state => state.subscriberList,
        }),
        ...mapGetters([
            'hasMoreThanOneSubscriber',
        ]),
        menuItems() {
            return flattenMenuSections(this.menuSections)
        },
        barItems() {
            return BAR_PATHS.map(path => this.menuItems.find(item => item.path === path))
        },
        moreSections() {
            return this.menuSections
                .map(section => ({
                    key: section.key,
                    title: section.title,
                    items: section.items.filter(item => !BAR_PATHS.includes(item.path) && item.isVisible()),
                }))
                .filter(section => section.items.length > 0)
        },
        themeLabel() {
            return isDarkTheme() ? 'Tema claro' : 'Tema escuro'
        },
        isMoreActionActive() {
            return this.menuItems.some(item => item.active && !BAR_PATHS.includes(item.path))
        },
    },
    watch: {
        $route(to, from) {
            this._activateRoute(to.path)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../utils/styles/constants.scss';

.bottom-menu {
    .bottom-menu-actions-container {
        position: fixed;
        background-color: var(--surface-1);
        left: 0;
        bottom: 0;
        width: 100vw;
        height: 65px;
        z-index: 10;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        border-top: 1px solid var(--tint-brand-border);

        ul.bottom-menu-items-container {
            list-style: none;
            width: auto;
            padding-left: 0;        
            padding: 10px 5px;
            text-align: center;

            li.bottom-menu-item {
                position: relative;
                display: inline-block;
                width: 25%;
                font-weight: 600;
                letter-spacing: 1px;

                &.active {
                    color: $color-primary;
                }

                .bottom-menu-text {
                    font-size: .7em;                    
                    text-transform: uppercase;
                }
            }
        }
    }

    .bottom-menu-more-actions-container {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        padding-bottom: 80px;
        background-color: var(--surface-1);
        overflow-y: auto;

        ul {
            list-style: none;
            padding-left: 0;

            li {
                padding: 0 5px 15px;

                &:last-of-type {
                    padding-bottom: 0;
                }

                p {
                   margin-bottom: 0;
                }
            }
        }

        .bottom-menu-more-actions-name-container {
            font-size: 1.35em;
            text-transform: uppercase;
            font-weight: 600;
            margin-bottom: 15px;

            &:after {
                content: '';
                display: block;
                width: 35px;
                height: 3px;
                margin-left: 5px;
                background-color:var(--brand-solid);
            }
            
            p {
                padding: 5px 5px 0;
                margin-bottom: 0;
            }
        }

        .bottom-menu-more-actions-section {
            margin-bottom: 20px;

            .bottom-menu-more-actions-section-title {
                padding: 0 5px;
                margin-bottom: 8px;
                font-size: 11px;
                font-weight: 600;
                letter-spacing: .06em;
                text-transform: uppercase;
                color: var(--text-faint);
            }
        }

        .bottom-menu-more-actions-list {
            .bottom-menu-more-actions-item {
                position: relative;
                text-transform: uppercase;
                padding-bottom: 0;
                margin-bottom: 15px;

                &:last-of-type {
                    margin-bottom: 0;
                }

                &.active {
                    color: $color-primary;
                    font-weight: 600;
                }

                p {
                    margin-bottom: 0;
                }
                
                .bottom-menu-more-actions-item-description {
                    
                }

                .bottom-menu-more-actions-item-icon {
                    position: absolute;
                    font-size: .8em;
                    top: 5px;
                    right: 5px;
                    color: var(--text-muted);
                }

                .bottom-menu-more-actions-item-theme {
                    position: absolute;
                    top: 50%;
                    right: -6px;
                    width: 32px;
                    height: 32px;
                    margin-top: -16px;
                    pointer-events: none;
                }
            }
        }
    }
}
</style>
